<template>
  <!-- <v-alert
    style="border-radius: 12px"
    dismissible
    :value="true"
    @input="onClose"
    prominent
    border="top"
    color="red lighten-2"
    dark
    type="warning"
  >
    {{ text }}
  </v-alert> -->

  <v-alert
    border="bottom"
    colored-border
    type="error"
    elevation="2"
    :value="true"
    @input="onClose"
    dismissible
  >
    {{ text }}
  </v-alert>
</template>

<script>
export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['text'],
  methods: {
    onClose() {
      this.$emit('dismissed');
    },
  },
};
</script>
